import {z as zod} from "zod";

export type MarketplaceIntelligenceWorkspaceCapabilityConfiguration = Record<string, never>;

export const marketplaceIntelligenceWorkspaceCapabilityConfigurationValidator: zod.ZodType<MarketplaceIntelligenceWorkspaceCapabilityConfiguration> =
    zod.strictObject({});
